<div class="range" *ngIf="(min || max)" [formGroup]="formGroup">
  <label>{{ label }}</label>
  <mat-slider [min]="min" [max]="max" [showTickMarks]="showTickMarks" [step]="step" [discrete]="discrete">
    <input matSliderStartThumb formControlName="min" />
    <input matSliderEndThumb formControlName="max" />
  </mat-slider>
</div>
